import Button from 'flarum/common/components/Button';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import app from 'flarum/forum/app';

export default class SortTicketsFilter extends Component {
  view() {
    let buttons = [];

    buttons.push(this.createButton('newest', 'id', 'DESC'));
    buttons.push(this.createButton('oldest', 'id', 'ASC'));
    buttons.push(this.createButton('recent_activity', 'last_posted_at', 'DESC'));
    buttons.push(this.createButton('least_recent', 'last_posted_at', 'ASC'));

    return Dropdown.component(
      {
        icon: 'fas fa-sort',
        label: 'Sort',
        buttonClassName: `Button`,
        menuClassName: 'Dropdown-menu--right',
      },
      buttons
    );
  }

  createButton(key, column, direction) {
    return Button.component(
      {
        className: 'Button',
        onclick: () => this.attrs.setSort(column, direction),
        icon: this.attrs.sortColumn === column && this.attrs.sortDirection === direction ? 'fas fa-check' : 'fa',
      },

      app.translator.trans(`v17development-flarum-support.forum.tickets.overview.sort.${key}`)
    );
  }
}
